export default {
  checkEmpty (text) {
    if (!text) {
      return false
    }
    return true
  },
  // 检查用户名
  checkNickname (nickname) {
    if (!(/^[^'"&<>]{1,30}$/.test(nickname))) {
      return false
    }
    return true
  },

  // 检查手机号格式
  checkMobile (mobile, country) {
    if (country === 86) {
      if (!(/^1[1-9]\d{9}$/.test(mobile))) {
        return false
      }
      return true
    } else {
      if (!(/^[\d]{5,11}$/.test(mobile))) {
        return false
      }
      return true
    }
  },

  // 检查手机验证码格式
  checkCaptcha (captcha) {
    if (!(/^\d{6}$/.test(captcha))) {
      return false
    }
    return true
  },

  // 检查图形验证码
  checkImgCaptcha (captcha) {
    if (!(/^.{4}$/.test(captcha))) {
      return false
    }
    return true
  },

  // 验证密码
  checkPassword (pwd) {
    if (!(/^.{6,24}$/.test(pwd))) {
      return false
    }
    return true
  }
}
